import type { CalcParams } from './ParamsPanel';

export function resolveEmptyRunning(
  params: CalcParams,
  baseKm: number,
  baseHours: number
): { km: number; hours: number } {
  const rawKm = parseFloat(params.emptyKm) || 0;
  const rawHours = parseFloat(params.emptyHours) || 0;

  if (params.emptyMode === 'pct') {
    return {
      km: Math.round(baseKm * (rawKm / 100) * 100) / 100,
      hours: Math.round(baseHours * (rawHours / 100) * 100) / 100,
    };
  }

  return { km: rawKm, hours: rawHours };
}
